import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCorporatePeriodClosingSearch = () => {
  const corporatePeriodClosingSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/corporate/period-closing/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { corporatePeriodClosingSearch }
}

export default InteractorCorporatePeriodClosingSearch
